// Standard signature appended to every AI-generated reply suggestion.
//
// The toll-free number resolves in this order:
//   1. `tollFreeNumber` returned by the suggestions API (backend/admin-managed)
//   2. REACT_APP_AI_SUPPORT_TOLL_FREE build-time override
//   3. the default below
export const DEFAULT_TOLL_FREE_NUMBER = '18002031425';

const SIGNATURE_NAME = 'Agribegri AI Support';

const resolveTollFree = (override) =>
  String(override || process.env.REACT_APP_AI_SUPPORT_TOLL_FREE || DEFAULT_TOLL_FREE_NUMBER).trim();

export const buildAiSignature = (tollFree) =>
  `– ${SIGNATURE_NAME}\nToll-Free: ${resolveTollFree(tollFree)}`;

// Appends the signature unless the text already carries the toll-free number
// (e.g. once the backend starts adding it itself), so it never appears twice.
export const withAiSignature = (text, tollFree) => {
  if (typeof text !== 'string' || !text.trim()) {
    return text;
  }
  const number = resolveTollFree(tollFree);
  if (text.replace(/\D/g, '').includes(number.replace(/\D/g, ''))) {
    return text;
  }
  return `${text.trimEnd()}\n${buildAiSignature(number)}`;
};

// Shapes a suggestions API payload ({ suggestions, commentText, tollFreeNumber? })
// so every suggestion ends with the signature.
export const signSuggestions = (data) => {
  if (!data) {
    return data;
  }
  return {
    ...data,
    suggestions: (data.suggestions ?? []).map((s) => withAiSignature(s, data.tollFreeNumber)),
  };
};
